import React from "react"
import { Accordion, AccordionDetails, AccordionSummary, Grid } from "@material-ui/core"
import { ExpandMore as ExpandMoreIcon } from "@material-ui/icons"

import { Text } from "letalkui"

import { PermissionEffect, Permissions } from "@/protocols/permission"
import { PermissionMacroGroupConfig } from "@/pages/Admin/Role/RoleDetails/permissionGroupsConfig"
import PermissionSubgroup from "@/pages/Admin/Role/RoleDetails/PermissionSubgroup"

import useStyles from "@/pages/Admin/Role/RoleDetails/PermissionGroupAccordion/styles"

type PermissionGroupAccordionProps = PermissionMacroGroupConfig & {
	permissions: Permissions
	onChangePermission: (permissions: Permissions) => void
	isExpanded: boolean
	onToggle: (id: string) => void
}

const PermissionGroupAccordion: React.FC<PermissionGroupAccordionProps> = (props) => {
	const {
		id,
		label,
		subgroups,
		permissions,
		onChangePermission,
		isExpanded,
		onToggle
	} = props

	const classes = useStyles()

	const { checkedCount, totalCount } = subgroups.reduce((countsAcc, subgroup) => {
		const storedActions = permissions[subgroup.feature] ?? []
		const items = subgroup.actions.map(action => storedActions.find(permission => permission.action === action) ?? { action, effect: "deny" as PermissionEffect })

		countsAcc.checkedCount += items.filter(item => item.effect === "allow").length
		countsAcc.totalCount += items.length

		return countsAcc
	}, { checkedCount: 0, totalCount: 0 })

	const subLabel = subgroups.map(subgroup => subgroup.label).join(" · ")

	return (
		<Accordion
			expanded={isExpanded}
			onChange={() => onToggle(id)}
			className={classes.accordion}
			elevation={0}
		>
			<AccordionSummary
				expandIcon={<ExpandMoreIcon fontSize="small" />}
				className={classes.accordionSummary}
			>
				<Grid container justifyContent="space-between" alignItems="center">
					<Grid item className={classes.accordionSummaryContent}>
						<Text.Body type="default" fontWeight="bold" className={classes.macroLabel}>{label}</Text.Body>
						<Text.Body type="small2" fontWeight="regular" className={classes.macroSubLabel}>{subLabel}</Text.Body>
					</Grid>
					<Grid item>
						<span className={classes.countPill}>{checkedCount}/{totalCount}</span>
					</Grid>
				</Grid>
			</AccordionSummary>
			<AccordionDetails className={classes.accordionDetails}>
				{subgroups.map(subgroup => (
					<PermissionSubgroup
						key={subgroup.id}
						{...subgroup}
						permissions={permissions}
						onChangePermission={onChangePermission}
					/>
				))}
			</AccordionDetails>
		</Accordion>
	)
}

export default PermissionGroupAccordion
